import Link from 'next/link';
import CreateWishlist from '@components/products/wishlist/CreateWishlist';

export default function WishlistActionListing(
    {
        wishlists,
        renderElement = null,
        renderButton = null,
        classes,
        wishlistType,
    },
) {
    function renderListings() {
        return wishlists.map((wishlist, index) => {
            return (
                <article key={index + '-' + wishlist.id} className={[ classes.item ].join(' ')}>
                    <Link href={(`/account/wishlists/edit/${wishlist.id}`)}>
                        <a className={'name'}>{wishlist.name}</a>
                    </Link>
                    {renderElement ? renderElement(wishlist) : null}
                    {renderButton ? renderButton(wishlist) : null}
                </article>
            );
        });
    }

    return <>
        {renderListings()}
        <div key={'key-actions'} className={[ classes.actionWrapper ].join(' ')}>
            <CreateWishlist type={wishlistType}></CreateWishlist>
        </div>
    </>;
}
